<template>
  <h3>バージョン履歴</h3>

  <HelloWorld date="2024/02/19" ver="1.2.0">
    <li>iPadに対応しました。</li>
    <li>ブックマーク用のウィジェットのを修正しました。</li>
    <li>Youtubeアプリからの共有処理を修正しました。</li>
  </HelloWorld>
  <HelloWorld date="2024/02/16" ver="1.1.1">
    <li>ウォッチリストへの追加の際にアプリを開かないようにしました。</li>
    <li>アプリの実行中・非実行中に関わらず、タイマー終了のプッシュ通知が届くようにしました。</li>
  </HelloWorld>
  <HelloWorld date="2024/02/15" ver="1.1.0">
    <li>ウォッチリスト機能を追加しました。</li>
    <li>ウォッチリストにはブラウザの共有機能などから登録できます。</li>
  </HelloWorld>
  <HelloWorld date="2024/02/09" ver="1.0.0">
    <li>配信を開始しました！</li>
  </HelloWorld>
</template>
  
<script lang="ts">
import { defineComponent } from 'vue';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src

export default defineComponent({
  name: 'UpdatedView',
  components: {
    HelloWorld,
  },
});
</script>
<style scoped>
div {
  text-align: left;
}
</style>